<template>
  <section class="custom-host-wrapper">
    <nav-top
      ref="topNav"
      @toggleBar="toggleBar"
    />
    <div
      class="custom-sidebar"
      :class="{'active': toggleClass, 'inactive': !toggleClass, 'hide-it': !isLoaded}"
    >
      <ul class="nav flex-column mb-0">
        <li class="nav-item">
          <b-link
            href="#"
            class="nav-link font-italic"
            @click="go('')"
          >
            <i class="fa fa-th-large mr-3"></i>
            <span class="custom-menu-link">Home</span>
          </b-link>
        </li>
        <li class="nav-item">
          <a
            href="#"
            class="nav-link font-italic"
            @click="serviceRequests"
          >
            <i class="fas fa-folder-open mr-3"></i>
            <span class="custom-menu-link">Service Requests</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            href="#"
            class="nav-link font-italic"
            @click="issues"
          >
            <i class="fas fa-folder-open mr-3"></i>
            <span class="custom-menu-link">Issues</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            href="#"
            class="nav-link font-italic"
            @click="go('location')"
          >
            <i class="fas fa-warehouse mr-3"></i>
            <span class="custom-menu-link">Location</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            href="#"
            class="nav-link font-italic"
            @click="go('user')"
          >
            <i class="fas fa-user mr-3"></i>
            <span class="custom-menu-link">User Profile</span>
          </a>
        </li>
        <li class="nav-item">
          <b-link
            href="#"
            class="nav-link font-italic"
            @click="go('about')"
          >
            <i class="fas fa-info mr-3"></i>
            <span class="custom-menu-link">About</span>
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            href="#"
            class="nav-link font-italic"
            @click="logout"
          >
            <i class="fas fa-sign-out-alt mr-3"></i>
            <span class="custom-menu-link">Logout</span>
          </b-link>
        </li>
      </ul>
    </div>
    <div
      class="custom-background"
      v-show="toggleClass"
      @click="closeMenu"
    ></div>
    <div
      class="custom-main"
      :style="{'height': psHeight + 'px'}"
    >
      <slot @event="processEvent" />
    </div>
    <div
      class="slideOut slideOutRight"
      v-bind:style="slideOutStyle"
      v-show="showRightSlideOut"
    >
      <div class="slideOutTitle"><a
          href="#"
          @click="closeSlideOut"
        ><i class="fas fa-times"></i></a><span>{{ slideOutTitle }}</span></div>
      <p>Stuff here.</p>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import NavTop from '@/components/navigation/nav-top'
import NavLeft from '@/components/navigation/nav-left'
export default {
  name: 'layout-sidebar',
  components: {
    NavTop,
    NavLeft
  },
  data() {
    return {
      version: window.config ? window.config.version : '',
      isLoaded: false,
      toggleClass: false,
      showRightSlideOut: false,
      slideOutStyle: '',
      slideOutTitle: '',
      psHeight: 0
    }
  },
  updated() {
    this.isLoaded = true
  },
  mounted() {
    this.psHeight = window.innerHeight - 70
    this.$root.$on('heartbeat', this.pulseHeartbeat)
    this.$root.$on('slideout', this.showSlideOut)
    window.addEventListener('resize', () => {
      this.psHeight = window.innerHeight - 70
      this.$eventBus.$emit('window-resize', this.psHeight - 100)
    })
  },
  computed: {
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    pulseHeartbeat(event) {
      console.log('An Event Occurred', event)
    },
    go(where) {
      window.location.assign(`/${where}`)
    },
    logout() {
      this.clearToken()
      window.location.assign('/')
    },
    toggleBar(toggle) {
      this.toggleClass = toggle
    },
    closeMenu() {
      this.$refs.topNav.closeMenu()
    },
    serviceRequests() {
      window.location.assign('/servicerequests/Dispatch')
    },
    issues() {
      window.location.assign('/issues')
    },
    closeSlideOut() {
      this.showRightSlideOut = false
      this.slideOutStyle = ''
      this.slideOutTitle = ''
      this.$root.$emit('closeSlideOut')
    },
    showSlideOut(options) {
      this.showRightSlideOut = false
      this.slideOutStyle = ''
      this.slideOutTitle = ''
      if (options.direction === 'right') {
        this.slideOutStyle = options.style
        this.slideOutTitle = options.title
        this.showRightSlideOut = true
      }
    }
  },
  beforeDestroy() {
    this.$root.$off('heartbeat')
    this.$root.$off('slideout')
  }
}
</script>
<style lang="scss" scoped>
.custom-host-wrapper {
  height: 100%;
}
.custom-main {
  padding: 0 10px 0 10px;
  overflow-x: hidden;
}
.custom-background {
  position: absolute;
  // margin-top: 8px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99998;
  // height: 100%;
  height: -moz-calc(100% - (70px));
  height: -webkit-calc(100% - (70px));
  height: calc(100% - (70px));
}
.hide-it {
  display: none;
}
.custom-sidebar {
  position: absolute;
  // margin-top: 8px;
  width: 17rem;
  background-color: rgb(121, 121, 121);
  z-index: 99999;
  // height: 100%;
  height: -moz-calc(100% - (70px));
  height: -webkit-calc(100% - (70px));
  height: calc(100% - (70px));
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
  li {
    padding-bottom: 1px;
    border-bottom: 1px solid #b6b6b6;
    white-space: nowrap;
  }
  a {
    font-size: 1.2em;
    font-weight: 600;
    color: #ffffff;
  }
  a:hover {
    color: #51b04a;
  }
}
.active {
  animation: slide-in 0.5s forwards;
  -webkit-animation: slide-in 0.5s forwards;
}
.inactive {
  animation: slide-out 0.5s forwards;
  -webkit-animation: slide-out 0.5s forwards;
}
@keyframes slide-in {
  100% {
    transform: translateX(0%);
  }
}
@-webkit-keyframes slide-in {
  100% {
    -webkit-transform: translateX(0%);
  }
}
@keyframes slide-out {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
@-webkit-keyframes slide-out {
  0% {
    -webkit-transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(-100%);
  }
}
.custom-menu-link {
  position: absolute;
  left: 70px;
}
.slideOut {
  background-color: #ffffff;
  position: absolute;
  z-index: 10001;
  -moz-box-shadow: 0px 10px 18px 0px #ccc;
  -webkit-box-shadow: 0px 10px 18px 0px #ccc;
  box-shadow: 0px 10px 18px 0px #ccc;
}
.slideOutTitle {
  position: relative;
  height: 44px;
  width: 100%;
  background-color: #338c2f;
  color: #ffffff;
  font-weight: 500;
  border-bottom: 1px solid #686868;
  margin: 0;
  padding-top: 6px;
  vertical-align: middle;
  text-align: center;
  font-size: 1.2em;
  a {
    position: absolute;
    color: #ffffff;
    top: 4px;
    left: 4px;
    height: 28px;
    width: 28px;
  }
}
.slideOutRight {
  display: block;
  right: 0;
  top: 0;
  height: 100%;
  border-top: 1px solid #686868;
  border-left: 1px solid #686868;
  border-bottom: 1px solid #686868;
}
</style>



// WEBPACK FOOTER //
// src/layouts/side-nav.vue